
export namespace Styling {
  export type OneOrRectValue<T> = T | {
    left: T;
    top: T;
    bottom: T;
    right: T;
  };

  export function formatOneOrRectValuePrefixed(
    prefix: string,
    value: OneOrRectValue<any>,
    unit: string = '') {
    let parts = [];

    if (typeof value === 'object') {
      if ('left' in value) {
        parts.push(`${prefix}-left: ${value.left ?? 0}${unit};`);
      }

      if ('top' in value) {
        parts.push(`${prefix}-top: ${value.top ?? 0}${unit};`);
      }

      if ('right' in value) {
        parts.push(`${prefix}-right: ${value.right ?? 0}${unit};`);
      }

      if ('bottom' in value) {
        parts.push(`${prefix}-bottom: ${value.bottom ?? 0}${unit};`);
      }
    }

    if (parts.length === 0) {
      parts.push(`${prefix}: ${value ?? 0}${unit};`);
    }

    return parts.join('\n');
  }
}
